module.exports = __webpack_public_path__ + "static/img/slide-1-bike.7afb616.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/slider/benefits/slide-1-bike.png
// module id = 26mG
// module chunks = 1